<template>
  <form
    ref="form"
    data-url="/sendRequest"
    :class="{ 'loading-opacity': preloader }"
    enctype="multipart/form-data"
  >
    <div class="row">
      <div class="col-md-12">
        <app-note
          class="mb-primary"
          :title="$t('information')"
          content-type="html"
          :notes="formInstruction1"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("bank") }}</label>
          <app-input
            type="select"
            v-model="inputs.bank_id"
            :required="true"
            :list="[
              { id: '', value: this.$t('select_option') },
              ...this.$store.state.accreditation.bank.map((item) => {
                return {
                  id: item.id,
                  value: `${item.name} - ${item.account_number}`,
                };
              }),
            ]"
            :disabled="true"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("transaction_type") }}</label>
          <app-input
            type="select"
            v-model="inputs.transaction_type_id"
            :required="true"
            :list="[
              { id: '', value: this.$t('select_option') },
              ...this.$store.state.accreditation.transactionType.map((item) => {
                return {
                  id: item.id,
                  value: item.name,
                };
              }),
            ]"
            :disabled="true"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <app-note
          class="mb-primary"
          :title="$t('note')"
          content-type="html"
          :notes="formInstruction2"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <label>{{ $t("transaction_date") }}</label>
        <app-input
          type="date"
          v-model="inputs.date"
          :placeholder="$t('select_valid_date')"
          :disabled="true"
        />
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("transaction_number") }}</label>
          <app-input type="text" v-model="inputs.number" :required="true" :disabled="true" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("amount") }}</label>
          <app-input type="number" v-model="inputs.amount" :required="true" :disabled="true"/>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("proof_payment") }}</label>
          <app-input
            type="file"
            :label="inputs.file ? inputs.file.name : $t('upload_your_file')"
            v-model="inputs.file"
            v-if="!inputs.attached_file"
            :disabled="true"
          />
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab"
              v-if="inputs.attached_file"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

          </div>
        </div>
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />

    <div class="row">
      <div class="col-12 mt-3">
        <!-- <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button> -->
      </div>
    </div>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../apiUrl";
export default {
  name: "SendRequest",

  mixins: [FormMixin],

  data() {
    return {
      preloader: false,
      inputs: {},
      bankList: [],
      transactionTypeList: [],
      formInstruction1: [this.$t("send_request_info1")],
      formInstruction2: [this.$t("send_request_info2")],
      deleteModal: false,
    };
  },

  created() {
    this.data();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      formData.append(
        "accreditation_application_id",
        this.$store.state.accreditation.id
      );
      this.save(formData);
    },

    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.$store.dispatch("getSendRequestOptions");

      this.preloader = true;

      this.axiosGet(
        `${actions.SEND_REQUEST}/show?accreditation_application_id=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            this.inputs = response.data ? response.data : {};
            this.inputs.date = new Date(Date.parse(this.inputs.date));
          }
        })
        .catch((error) => {
          console.log("SendRequest: " + error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    confirmed() {
      this.deleteModal = false;
      this.inputs.file = null;
      this.inputs.attached_file = null;
      this.inputs.delete_file = 0;
    },

    cancelled() {
      this.deleteModal = false;
    },

    openTab() {
      const w = window.open(this.inputs.attached_file.path, "_blank");
      w.focus();
    },
  },
};
</script>